import React from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { PageModel } from 'client/data/models/page';
import { getAboutArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { getAboutArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ResearchEntry } from 'site-modules/editorial/components/about-article/research-entry/research-entry';

function AboutArticleUI({ content = null, splat = null, articleId, isAppExtensionPage = false }) {
  if (!content) {
    return null;
  }

  const { title } = content;
  const mainEntries = content.child('main').children();
  const rightRailEntries = content.child('right-rail').children();
  const footerEntries = content.child('footer').children();

  return (
    <Container tag="main" id="main-content" tabIndex={-1} className="about-article pb-2">
      {!isAppExtensionPage && (
        <Breadcrumbs className="px-0 mb-2" data={getAboutArticleBreadcrumbs({ splat, articleId, title })} />
      )}
      <h1 className="heading-2 mb-1_5">{title}</h1>
      <Row>
        <Col xs={12} lg={8} className="mb-1_5 mb-lg-0">
          {/* main */}
          {mainEntries.map((entry, index) => {
            const key = `main-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
        <Col xs={12} lg={4} className="mb-1_5 mb-lg-0">
          {/* right-rail */}
          {rightRailEntries.map((entry, index) => {
            const key = `right-rail-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
        <Col xs={12} lg={8}>
          {/* footer */}
          {footerEntries.map((entry, index) => {
            const key = `footer-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
      </Row>
    </Container>
  );
}

AboutArticleUI.propTypes = {
  articleId: PropTypes.string.isRequired,
  splat: PropTypes.string,
  content: CmsEntities.Content,
  isAppExtensionPage: PropTypes.bool,
};

export const AboutArticle = connectToModel(AboutArticleUI, {
  content: bindToContent(({ splat, articleId }) => getAboutArticleContentPath(splat, articleId)),
  isAppExtensionPage: bindToPath('isAppExtensionPage', PageModel),
});
